import './app-info.scss'

const ENV = process.env.REACT_APP_ENV
const VERSION = process.env.REACT_APP_VERSION

const AppInfo: React.FC = () => {
  return (
    <p className="info">
      Env : {ENV}
      <br /> v: {VERSION}
    </p>
  )
}

export default AppInfo
